'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getModuleSnippet } from 'DesignData/lib/copySnippets';
import UIFormControl from 'UIComponents/form/UIFormControl';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import UICopyTextArea from 'UIComponents/input/UICopyTextArea';
import UICopyButton from 'UIComponents/button/UICopyButton';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.moduleSnippet.${key}`;

export default class ModuleSnippet extends Component {
  constructor(props) {
    super(props);

    this.getSnippet = () => {
      const {
        snippet
      } = this.state;
      this.setState({
        snippet: this.createSnippet(this.props)
      });
      return snippet;
    };

    this.renderButton = () => {
      return /*#__PURE__*/_jsx(UICopyButton, {
        className: "m-top-2",
        size: "extra-small",
        use: "tertiary-light",
        valueWhenCopied: this.getSnippet,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('snippetInput.buttonText')
        })
      });
    };

    this.state = {
      snippet: this.createSnippet(props)
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.customWidgetId !== nextProps.customWidgetId || this.props.customWidgetLabel !== nextProps.customWidgetLabel || this.state.snippet !== nextState.snippet;
  }

  componentDidUpdate(prevProps) {
    if (this.props.customWidgetId !== prevProps.customWidgetId || this.props.customWidgetLabel !== prevProps.customWidgetLabel) {
      this.setState({
        snippet: this.createSnippet(this.props)
      });
    }
  }

  createSnippet(props) {
    return getModuleSnippet({
      moduleId: props.moduleId,
      name: props.customWidgetLabel,
      path: props.customWidgetPath
    });
  }

  render() {
    const label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('snippetInput.label')
    });

    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('helpText')
      }), /*#__PURE__*/_jsx(ToolFieldset, {
        children: /*#__PURE__*/_jsx(UIFormControl, {
          className: "m-top-3",
          label: label,
          children: /*#__PURE__*/_jsx(SidebarInput, {
            inputComponent: UICopyTextArea,
            use: "code",
            buttonRowRenderer: this.renderButton,
            value: this.state.snippet
          })
        })
      })]
    });
  }

}
ModuleSnippet.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  moduleId: PropTypes.number,
  customWidgetLabel: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  customWidgetPath: PropTypes.string.isRequired
};